<div class="form-header text-center">
  <a [routerLink]="session_info?.last_routes.new_home || '/'" class="d-lg-none">
    <img loading="lazy" src="assets/logos/logo.png" height="30" class="mb-4">
  </a>
  <h2>Two Step Verification</h2>
</div>
<div class="text-center" *ngIf="data" [formGroup]="data">
  <img loading="lazy" src="assets/confirmation.png" width="40%" class="my-4">
  <p class="mb-1">Enter the {{data.get('otp').value.length}} digit code sent to your email</p>
  <b class="dark">{{data.get('email').value}}</b>

  <div class="row g-2 g-sm-3 mt-2">
    <ng-container *ngFor="let o_ of data.get('otp')['controls']; let i = index" formArrayName="otp">
      <div class="col">
        <input type="text" [formControlName]="i" [id]="'otp_' + i" (keyup)="jumpToNext(i)"
          class="form-control text-uppercase text-center" maxlength="1">
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf="authState$ | async; let auth_state">
    <button class="btn btn-secondary btn-block mt-5 mb-2" (click)="submit_clicked.emit(true)"
      [disabled]="auth_state.status === state_statuses.PROCESSING">
      <app-inline-loader *ngIf="auth_state.status === state_statuses.PROCESSING"></app-inline-loader>
      <span *ngIf="auth_state.status !== state_statuses.PROCESSING">Login</span>
    </button>
  </ng-container>

  <!-- <p class="mt-3">Didn’t get the code ? <a href="#">Resend</a></p> -->
</div>